export const ActionTypes = {
  LOADING: "UPDATE_DECISION_LOADING",
  ERROR: "UPDATE_DECISION_ERROR",
  SUCCESS: "UPDATE_DECISION_SUCCESS",
  EDIT: "UPDATE_DECISION_EDIT",
};
